require('./dist/angular-dnd');
module.exports = 'dnd';
